import React from 'react'

const Header = ({ title }) => (
    <h3 style={{ textAlign: 'center', padding: '20px' }}>{title}</h3>
)

export default Header
